module.exports = __webpack_public_path__ + "c5d52ccff7e75ec9dae0f16080500e2e.png";